import type { SxProps } from "@mui/material";

export const buttonStyle: SxProps = {
  position: "relative",
};

export const spinnerStyle: SxProps = {
  mr: 1,
};
